import PanelSettings from "./PanelSettings";

export default PanelSettings;
